import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

import { dynamicFontSize } from '~/utilities/helpers';

const StyledChip = styled.span`
    display: inline-block;
    color: ${({ theme }) => theme.colors.accent.blue};
    border: 2px solid ${({ theme }) => theme.colors.accent.blue};
    border-radius: 20px;
    font-family: ${({ theme }) => theme.fonts.heading};
    font-weight: ${({ theme }) => theme.fontWeights.black};
    font-size: ${dynamicFontSize(1.2, 1.6, 1.9)};
    text-transform: uppercase;
    line-height: 1;
    padding: 12px 15px 10px;
`;

const Chip = ({ children, className = '' }) => {
    return <StyledChip {...{ className }}>{children}</StyledChip>;
};

Chip.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string
};

export default Chip;
